import React from 'react';
import cn from 'bem-cn';

import './BigTitleWithText.scss';

type BigTitleWithTextProps = {
    title: string;
    text: string;
};

const b = cn('big-title-with-text');

export const BigTitleWithText: React.FC<BigTitleWithTextProps> = ({ title, text }) => {
    return (
        <section className={b()}>
            <h1 className={b('title')}>{title}</h1>
            <p className={b('text')}>{text}</p>
        </section>
    );
};
